import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobEstimateActions'
import * as api from '../../api/job/estimates'

export function* jobEstimatesRefresh(action) {
  try {
    const payload = yield call(api.getJobEstimates, action.jobId)
    yield put({ type: constants.JOB_ESTIMATES_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_ESTIMATES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobEstimates() {
  yield takeLatest(constants.JOB_ESTIMATES_REFRESH.ACTION, jobEstimatesRefresh)
}

function* sagaCreateJobEstimate(action) {
  try {
    const payload = {
      estimate_data: {
        overhead_total: action.estimateCounts.estimateOverheadTotal,
        markup_total: action.estimateCounts.estimateMarkupTotal,
        tax_total: action.estimateCounts.estimateTaxTotal,
        total: action.estimateCounts.estimateTotal,
        description: action.content.description,
        estimate_template_id: action.content.estimateTemplateId,
        overhead: action.content.overhead,
        markup: action.content.markup,
        tax: action.content.tax,
        grand_total: action.estimateCounts.estimateGrandTotal,
        created_by_id: 1,
        updated_by_id: 1
      },
      job_id: action.jobId,
      estimate_groups: action.estimateGroups,
      estimate_items: action.estimateItems
    }
    if (action.content.estimate_template_id !== '')
      payload.estimate_data.estimate_template_id = action.content.estimate_template_id
    yield call(api.createJobEstimate, payload)
    yield put({ type: constants.JOB_ESTIMATE_CREATE.SUCCESS, payload })
    yield call(jobEstimatesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_ESTIMATE_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobEstimate() {
  yield takeLatest(constants.JOB_ESTIMATE_CREATE.ACTION, sagaCreateJobEstimate)
}

function* sagaUpdateJobEstimate(action) {
  try {
    const payload = {
      job_id: action.jobId,
      estimate_id: action.estimateId,
      description: action.description,
      updated_by_id: action.userId,
      user_id: 1,
      files: action.files
    }
    yield call(api.updateJobEstimate, payload)
    yield put({ type: constants.JOB_ESTIMATE_UPDATE.SUCCESS, payload })
    yield call(jobEstimatesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_ESTIMATE_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobEstimate() {
  yield takeLatest(constants.JOB_ESTIMATE_UPDATE.ACTION, sagaUpdateJobEstimate)
}

function* sagaDeleteJobEstimate(action) {
  try {
    const payload = {
      estimate_id: action.estimateId
    }
    yield call(api.deleteJobEstimate, payload)
    yield put({ type: constants.JOB_ESTIMATE_DELETE.SUCCESS, payload })
    yield call(jobEstimatesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_ESTIMATE_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobEstimate() {
  yield takeLatest(constants.JOB_ESTIMATE_DELETE.ACTION, sagaDeleteJobEstimate)
}

function* getEstimateSections(action) {
  try {
    const payload = yield call(api.getEstimateSections, action.estimateId)
    yield put({ type: constants.GET_JOB_ESTIMATE_SECTIONS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_JOB_ESTIMATE_SECTIONS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetEstimateSections() {
  yield takeLatest(constants.GET_JOB_ESTIMATE_SECTIONS.ACTION, getEstimateSections)
}

function* getEstimateItems(action) {
  try {
    const payload = yield call(api.getEstimateItems, action.estimateId.estimateId)
    yield put({ type: constants.GET_JOB_ESTIMATE_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_JOB_ESTIMATE_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetEstimateItems() {
  yield takeLatest(constants.GET_JOB_ESTIMATE_ITEMS.ACTION, getEstimateItems)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobEstimates),

    fork(watchCreateJobEstimate),
    fork(watchUpdateJobEstimate),
    fork(watchDeleteJobEstimate),

    fork(watchGetEstimateSections),
    fork(watchGetEstimateItems)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobEstimateSaga.js